"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceRequestToJSON = exports.PriceRequestFromJSONTyped = exports.PriceRequestFromJSON = exports.instanceOfPriceRequest = void 0;
var runtime_1 = require("../runtime");
var CampaignAdProduct_1 = require("./CampaignAdProduct");
var Targets_1 = require("./Targets");
/**
 * Check if a given object implements the PriceRequest interface.
 */
function instanceOfPriceRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "adProduct" in value;
    isInstance = isInstance && "startDate" in value;
    isInstance = isInstance && "targets" in value;
    return isInstance;
}
exports.instanceOfPriceRequest = instanceOfPriceRequest;
function PriceRequestFromJSON(json) {
    return PriceRequestFromJSONTyped(json, false);
}
exports.PriceRequestFromJSON = PriceRequestFromJSON;
function PriceRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'adProduct': (0, CampaignAdProduct_1.CampaignAdProductFromJSON)(json['ad_product']),
        'startDate': (new Date(json['start_date'])),
        'endDate': !(0, runtime_1.exists)(json, 'end_date') ? undefined : (new Date(json['end_date'])),
        'targets': (0, Targets_1.TargetsFromJSON)(json['targets']),
    };
}
exports.PriceRequestFromJSONTyped = PriceRequestFromJSONTyped;
function PriceRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'ad_product': (0, CampaignAdProduct_1.CampaignAdProductToJSON)(value.adProduct),
        'start_date': (value.startDate.toISOString()),
        'end_date': value.endDate === undefined ? undefined : (value.endDate.toISOString()),
        'targets': (0, Targets_1.TargetsToJSON)(value.targets),
    };
}
exports.PriceRequestToJSON = PriceRequestToJSON;
